import React, {Component} from 'react';
import LoginForm from '../../components/LoginForm/LoginForm'
import {connect} from "react-redux";
import * as actions from "../../actions/ApiActions";
import {Redirect} from "react-router-dom";
import Spinner from "../../components/Spinner/Spinner";
import Content from "../../components/Content/Content";
import Button from '../../components/Button/Button';

class LoginContainer extends Component {
    constructor(props) {
        super(props);

        this.login = this.login.bind(this);
    }

    login(username, password) {
        const {loginRequest, history} = this.props;

        loginRequest({
            email: username,
            password: password,
            role: "doctor"
        });

        return false;
    }

    componentDidMount() {
        const {loadUserData} = this.props;

        loadUserData();
    }

    render() {
        if (this.props.auth.authToken && !this.props.auth_loading) {
            return (
                <Redirect to={'/dashboard'}/>
            );
        }

        if (this.props.auth_loading && this.props.auth_error === false) {
            return (
                <Content>
                    <Spinner/>
                </Content>
            )
        }

        return (
            <div>
                <LoginForm loginAction={this.login} error={this.props.auth.error}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        auth_loading: state.auth_loading,
        auth_error: state.auth_error,
    };
}

export default connect(mapStateToProps, actions)(LoginContainer);



// WEBPACK FOOTER //
// ./src/container/public/LoginContainer.js